module.exports = __webpack_public_path__ + "img/SII-logo.899e6f76.png";